__turbopack_context__.v({
  "additionalText": "style-module-scss-module__jmlrcG__additionalText",
  "awardItem": "style-module-scss-module__jmlrcG__awardItem",
  "awardsList": "style-module-scss-module__jmlrcG__awardsList",
  "awardsTable": "style-module-scss-module__jmlrcG__awardsTable",
  "date": "style-module-scss-module__jmlrcG__date",
  "groupItem": "style-module-scss-module__jmlrcG__groupItem",
  "groupTitle": "style-module-scss-module__jmlrcG__groupTitle",
  "hasLink": "style-module-scss-module__jmlrcG__hasLink",
  "seeCaseLabel": "style-module-scss-module__jmlrcG__seeCaseLabel",
});
